import React from 'react';

const TelemetryContext = React.createContext();

export default TelemetryContext;
